import {useEffect, useContext} from 'react'
import {withRouter} from 'react-router'
import Snowplow from '../../Snowplow'
import {SnowplowReactContext} from '../../SnowplowContextManager'
import {cleanUtmParameters} from '../../utils'

const PageViewAnalytics = ({
    location,
    history,
    analyticsContexts,
    url,
    setCustomUrl = () => {},
    onPageView = () => {}
  }) => {
  if (!global.window) {
    return null
  }

  const contexts = analyticsContexts || useContext(SnowplowReactContext),
    {pathname} = location,
    customUrl = url || setCustomUrl(pathname),
    options = customUrl ? {pageUrl: customUrl} : {}

  if (!window.cleanUtmParametersOnLoad) {
    window.cleanUtmParametersOnLoad = () => cleanUtmParameters(location, history)
    window.addEventListener('load', window.cleanUtmParametersOnLoad)
  }

  useEffect(() => {
    Snowplow.trackPageView(null, contexts, options)
    onPageView(options)

    return () => {
      window.removeEventListener('load', window.cleanUtmParametersOnLoad)
      delete window.cleanUtmParametersOnLoad
    }
  }, [pathname])

  return null
}

export default withRouter(PageViewAnalytics)
